import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { v4 as uuid } from 'uuid'
import { Severity } from 'widget/Notifications'

export type NoticeInState = {
  text: string
  severity: Severity
  id: string
}

export type Notice = {
  text: string
  severity: Severity
}

export type NoticeState = {
  notifications: Array<NoticeInState> | undefined
}

const initialState: NoticeState = {
  notifications: [],
}

export const noticeSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    // добавление уведомления
    addNotification: (state, action: PayloadAction<Notice>) => {
      const newNotice = action.payload
      if (state?.notifications?.some(notice => notice.text === newNotice.text))
        return
      state?.notifications?.push({ ...newNotice, id: uuid() })
    },
    // удаление уведомления
    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state?.notifications?.filter(
        notification => notification.id !== action.payload,
      )
    },
  },
})

export const { addNotification, removeNotification } = noticeSlice.actions
export const { actions } = noticeSlice

export default noticeSlice.reducer
